import { IntlShape } from 'react-intl';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { GridFilterModel, GridLogicOperator } from '@mui/x-data-grid-pro';
import { GridColumnFieldIssue } from 'components/common/dataGrid/columnsFactory/types';
import { CustomFilterOperator } from 'components/common/dataGrid/columnsFactory/customFilters/operators/constants';
import { SavedFilterPreset } from 'components/common/dataGrid/filterPanelWrapper/types';

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

function createAssignedToMeFilterModel(userId: string): GridFilterModel {
  return {
    items: [
      {
        id: 'assigned-executor',
        field: GridColumnFieldIssue.executor,
        operator: CustomFilterOperator.CONTAINS,
        value: [userId],
      },
      {
        id: 'assigned-assignee',
        field: GridColumnFieldIssue.assignee,
        operator: CustomFilterOperator.CONTAINS,
        value: [userId],
      },
    ],
    logicOperator: GridLogicOperator.Or,
  };
}

function createReportedByMeFilterModel(userId: string): GridFilterModel {
  return {
    items: [
      {
        id: 'created-by-me',
        field: GridColumnFieldIssue.createdBy,
        operator: CustomFilterOperator.CONTAINS,
        value: [userId],
      },
    ],
  };
}

function createDeadlineNext7DaysFilterModel(): GridFilterModel {
  const now = Date.now();
  const in7Days = now + SEVEN_DAYS_MS;

  return {
    items: [
      {
        id: 'deadline-7-days',
        field: GridColumnFieldIssue.targetCompletionDate,
        operator: CustomFilterOperator.DATE_RANGE,
        value: { start: now, end: in7Days },
      },
    ],
  };
}

export function getIssueStaticFilterPresets(
  intl: IntlShape,
  userId: string
): SavedFilterPreset[] {
  return [
    {
      id: 'issues-static-assigned-to-me',
      name: formatTranslation(intl, FiltersTranslationKeys.presetAssignedToMe),
      model: createAssignedToMeFilterModel(userId),
    },
    {
      id: 'issues-static-reported-by-me',
      name: formatTranslation(intl, FiltersTranslationKeys.presetReportedByMe),
      model: createReportedByMeFilterModel(userId),
    },
    {
      id: 'issues-static-deadline-7-days',
      name: formatTranslation(intl, FiltersTranslationKeys.presetDeadline7Days),
      model: createDeadlineNext7DaysFilterModel(),
    },
  ];
}
